import React, { useEffect } from "react";
import OurExpertise from "./HomeComponents/OurExpertise";
import WhatWeLike from "./HomeComponents/WhatWeLike";
import FooterCTA from "./HomeComponents/FooterCTA";

const Services = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <div className="banner ourservices section" id="home">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1>
            Our <span>Services</span>
          </h1>
        </div>
        
      </div>
      <OurExpertise />
      <div className="mb-5"></div>
      <WhatWeLike />
      <div className="mb-5"></div>
      <FooterCTA />
    </>
  );
};

export default Services;
